import TreeMenu from '../../common/TreeMenu';
import { TYPE_TICKET } from 'utils/data';
import usePermission from '../../../hooks/usePermission';

export default function MasterSetting() {
  const dataTree = [
    {
      id: 'CLASS',
      title: 'Lớp',
      url: '/master-setting/grade',
      children: [],
    },
    {
      id: 'SKILL_TYPE',
      title: 'Năng lực',
      url: '/master-setting/skill-type',
    },
    {
      id: 'SUBJECT',
      title: 'Môn học',
      url: '/master-setting/subject',
      children: [],
    },
    {
      id: 'EXERCISE_FORMAT',
      title: 'Dạng bài tập',
      url: '/master-setting/exercise-format',
    },
    {
      id: 'TEST_BANK',
      title: 'Ngân hàng',
      url: '/master-setting/test-bank',
    },
    {
      id: 'TEST_TEMPLATE',
      title: 'Template đề thi',
      url: '/master-setting/test-template',
      children: [],
    },
    {
      id: 'TICKET_STORE',
      title: 'Gian hàng',
      children: [
        {
          id: 'TICKET_STORE_PRACTICE',
          title: 'Gói điểm',
          url: `/master-setting/ticket-store/${TYPE_TICKET.TYPE_TICKET_PRACTICE.toLowerCase()}`,
          children: [],
        },
      ],
    },
    {
      id: 'THEORY',
      title: 'Lý thuyết',
      url: '/master-setting/theory',
      children: [],
    },
    {
      id: 'LECTURE',
      title: 'Bài giảng',
      url: '/master-setting/lecture',
      children: [],
    },
    {
      id: 'GAME',
      title: 'Trò chơi',
      url: '/master-setting/game',
      children: [],
    },
    {
      id: 'FEATURE',
      title: 'Tính năng',
      url: '/master-setting/feature',
      children: [],
    },
    {
      id: 'PLAN',
      title: 'Gói',
      url: '/master-setting/plan',
      children: [],
    },
    {
      id: 'ORDER',
      title: 'Đơn hàng',
      url: '/master-setting/order',
      children: [],
    },
    {
      id: 'USER_SUBSCRIPTION',
      title: 'Đăng ký gói',
      url: '/master-setting/user-subscription',
      children: [],
    },
  ];

  usePermission(['ROLE_ADMIN']);

  return <TreeMenu dataTree={dataTree} />;
}
